﻿import ImageEditorsApi from './ImageEditorsApi';
import * as types from './ImageEditorActionTypes';
import IImageEditor from './IImageEditor';
import IImageEditorInput from './IImageEditorInput';
import IImageEditorFirm from './IImageEditorFirm';

function loadImageEditorsSuccess(userResult: any) {
    return { type: types.LOAD_IMAGE_EDITORS_SUCCESS, userResult };
}

export function getImageEditors() {
    return function (dispatch: any, getState: any) {
        return ImageEditorsApi.getImageEditors().then((result: any) => {
            dispatch(loadImageEditorsSuccess(result));
        });
    };
}

function addImageEditorSuccess(userResult: any) {
    return { type: types.ADD_IMAGE_EDITOR_USER_SUCCESS, userResult };
}

export function addImageEditor(user: IImageEditorInput) {
    return function (dispatch: any, getState: any) {
        return ImageEditorsApi.addUser(user).then((result: any) => {
            dispatch(addImageEditorSuccess(result));
        });
    };
}

function getEditImageEditorSuccess(userResult: any) {
    return { type: types.GET_EDIT_IMAGE_EDITOR_SUCCESS, userResult };
}

export function getEditImageEditor(id: number) {
    return function (dispatch: any, getState: any) {
        return ImageEditorsApi.getEditImageEditor(id).then((result: IImageEditorInput) => {
            dispatch(getEditImageEditorSuccess(result));
        });
    };
}

function updateImageEditorSuccess(userResult: any) {
    return { type: types.UPDATE_IMAGE_EDITOR_USER_SUCCESS, userResult };
}

export function updateImageEditor(id: number, imageEditor: IImageEditorInput) {
    return function (dispatch: any, getState: any) {
        return ImageEditorsApi.updateUser(id, imageEditor).then((result: any) => {
            dispatch(updateImageEditorSuccess(result));
        });
    };
}

function deleteImageUserSuccess(id: number) {
    return { type: types.DELETE_IMAGE_EDITOR_USER_SUCCESS, id };
}

export function deleteImageEditorUser(id: number) {
    return function (dispatch: any, getState: any) {
        return ImageEditorsApi.deleteUser(id).then(() => {
            dispatch(deleteImageUserSuccess(id));
        });
    };
}

function getNewImageEditorSuccess(result: IImageEditorFirm[]) {
    return { type: types.GET_NEW_IMAGE_EDITOR_SUCCESS, result: result };
}

export function getNewImageEditor() {
    return function (dispatch: any, getState: any) {
        return ImageEditorsApi.getNewImageEditor().then((result: IImageEditorFirm[]) => {
            dispatch(getNewImageEditorSuccess(result));
        });
    };
}
